import { useFormDataQuery } from '@/api/getters';
import AfterDoc from '@/components/ui/AfterDoc';
import Button, { ButtonRightArrow } from '@/components/ui/Button';
import { FLOODING, PRODUCT } from '@/consts';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const ThankYouNotQualifyIssuerDecision = () => {
  const { i18n } = useLingui();
  const { data } = useFormDataQuery();

  const issueType = data?.product.additional_info.issue_type?.value;

  const isFlooding = issueType === FLOODING;
  return (
    <AfterDoc
      consultant={CONSULTANTS.MARTA_ASSISTANT}
      thankYouMessage={i18n.t(
        'Niestety, na ten moment, nie możemy podjąć dalszych działań w Twojej sprawie'
      )}
      otherButton={
        isFlooding ? (
          <a
            href="https://gen.helpfind.pl/odwolanie-od-decyzji-ubezpieczyciela-z-powodu-zalania-mieszkania/"
            className="max-w-fit"
          >
            <Button>
              {i18n.t('Przejdź do generatora')}

              <ButtonRightArrow />
            </Button>
          </a>
        ) : undefined
      }
      withButton={!isFlooding}
      productId={PRODUCT.HOUSE_HOLD}
    >
      <p>
        {i18n.t(
          'Decyzja ubezpieczyciela o odmowie wypłaty odszkodowania uniemożliwia nam dalsze prowadzenie sprawy na tym etapie. Jednak to nie zamyka drogi – zachęcamy do złożenia odwołania.'
        )}
      </p>
      <div>
        <p className="body pb-2">
          {i18n.t(
            'Jeśli zdecydujesz się na ten krok i decyzja zostanie zmieniona, chętnie podejmiemy dalsze działania i pomożemy w Twojej sprawie.'
          )}
        </p>
        {isFlooding && (
          <p>
            {i18n.t(
              'Poniżej znajdziesz link do generatora formularza odwołania, który pomoże Ci w przygotowaniu dokumentu.'
            )}
          </p>
        )}
      </div>
      <p className="body font-semibold">
        {i18n.t(
          'W razie pytań zapraszamy do kontaktu – chętnie wyjaśnimy szczegóły.'
        )}
      </p>
    </AfterDoc>
  );
};

export default ThankYouNotQualifyIssuerDecision;
